<template>
  <div v-if="id === 2" style="background-color: #f5f5f5">
    <b-container>
      <b-row>
        <b-col>
          <h5 class="mb-5" align="center">코더스하이와 함께한 UX 프로젝트</h5>
          <ul class="timeline">
            <li v-for="history in codershighUXHistories" :key="history.title">
              <a target="_blank" href="https://www.totoprayogo.com/#">{{ history.title }}</a>
              <p v-html="history.description"></p>
            </li>
          </ul>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: Number
    }
  },
  data() {
    return {
      codershighUXHistories: [
        {
          title: "디자인 진흥원",
          description: "디자이너를 위한 앱개발 과정 1기 \n\n - 4개의 앱을 앱스토어에 등록 \n - 2개의 앱이 한국 앱 스토어 마켓에서 ‘최신 및 주목할 만한 앱(New & Noteworthy)’에 선정 \n\n 디자이너를 위한 앱개발 과정 2기\n - 5개의 앱을 앱스토어에 등록\n - 2개의 앱이 한국 앱 스토어 마켓에서 ‘최신 및 주목할 만한 앱(New & Noteworthy)’에 선정\n"
            .split("\n")
            .join("<br/>")
        },
        {
          title: "서울대학교 정보문화학과(ITCT)",
          description: "서울대학교 정보문학과(2016년 ~ 2018년)\n\n - 서울대학교 정보문학과는 입학 정원이 없는 다양한 전공의 학생들이 모이며, \n Application Protype을 만들어 갔습니다. \n\n - 애플의 앱 디자인 사이클을 기반으로 어플리케이션 디자인 \n- 프로토타입 개발"
            .split("\n")
            .join("<br/>")
        },
        {
          title: "LINE+",
          description: "2016년  LINE+ 앱 표준화 팀 교육 - 디자이너를 위한 개발 기술(Xcode Storyboard, Autolayout, Prototyping)2017년 LINE+ - 앱 표준화 팀 프로토타입 외주 제작(Shell App 제작)"
            .split("\n")
            .join("<br/>")
        },
        {
          title: "연세대학교 언더우드국제대학 정보인터렉션디자인(IID)",
          description: "서울대학교 정보문학과(2016년 ~ 2018년)\n\n - 서울대학교 정보문학과는 입학 정원이 없는 다양한 전공의 학생들이 모이며, \n Application Protype을 만들어 갔습니다. \n\n - 애플의 앱 디자인 사이클을 기반으로 어플리케이션 디자인 \n- 프로토타입 개발"
            .split("\n")
            .join("<br/>")
        },
        {
          title: "창업 진흥원",
          description: "서울대학교 정보문학과(2016년 ~ 2018년)\n\n - 서울대학교 정보문학과는 입학 정원이 없는 다양한 전공의 학생들이 모이며, \n Application Protype을 만들어 갔습니다. \n\n - 애플의 앱 디자인 사이클을 기반으로 어플리케이션 디자인 \n- 프로토타입 개발"
            .split("\n")
            .join("<br/>")
        }
      ]
    };
  }
};
</script>

<style>
ul.timeline {
  list-style-type: none;
  position: relative;
}
ul.timeline:before {
  content: " ";
  background: #d4d9df;
  display: inline-block;
  position: absolute;
  left: 29px;
  width: 2px;
  height: 100%;
  z-index: 400;
}
ul.timeline > li {
  margin: 20px 0;
  padding-left: 20px;
}
ul.timeline > li:before {
  content: " ";
  background: white;
  display: inline-block;
  position: absolute;
  border-radius: 50%;
  border: 3px solid #22c0e8;
  left: 20px;
  width: 20px;
  height: 20px;
  z-index: 400;
}
</style>
